import { render, staticRenderFns } from "./fundProtocol.vue?vue&type=template&id=2cc52645"
import script from "./fundProtocol.vue?vue&type=script&lang=js"
export * from "./fundProtocol.vue?vue&type=script&lang=js"
import style0 from "./fundProtocol.vue?vue&type=style&index=0&id=2cc52645&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports